import { render, staticRenderFns } from "./SubKbliEdit.vue?vue&type=template&id=a413b594&scoped=true&"
import script from "./SubKbliEdit.vue?vue&type=script&lang=js&"
export * from "./SubKbliEdit.vue?vue&type=script&lang=js&"
import style0 from "./SubKbliEdit.vue?vue&type=style&index=0&id=a413b594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a413b594",
  null
  
)

export default component.exports